import {Navigate, NonIndexRouteObject} from "react-router"
import {
    navigationStore,
    pageQueryStore,
    slsCreateStore,
    slsCustomerStore,
    slsDetailStore,
    slsOverviewStore,
    slsUserStore,
    slsWarehouseCreateStore,
    slsWarehouseDetailStore,
    slsWarehouseListStore,
    validationStore
} from "../store";
import React from "react";
import {SlsApp} from "../components/app/SlsApp";
import {ErrorPage} from "../components/page";


const sls: NonIndexRouteObject[] = [
    {
        path: `/sls`,
        element: <SlsApp mode={'overview'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            const searchParams = new URL(request.url).searchParams
            pageQueryStore.updateSystem('sls', searchParams)
            await slsCustomerStore.init()
            await slsUserStore.init()
            slsOverviewStore.page = parseInt(searchParams.get("page") || "") || 1
            slsOverviewStore.size = parseInt(searchParams.get("size") || "") || 25
            slsOverviewStore.query = searchParams.get('q') || undefined
            slsOverviewStore.customerId = searchParams.get('customerId') || undefined
            slsOverviewStore.documentExistence = searchParams.getAll('documentExistence') || undefined
            slsOverviewStore.status = searchParams.getAll('status') || undefined
            slsOverviewStore.origins = searchParams.getAll('origins') || undefined
            slsOverviewStore.usernames = searchParams.getAll('usernames') || []
            slsOverviewStore.fromRelative = searchParams.get('fromRelative') || undefined
            slsOverviewStore.toRelative = searchParams.get('toRelative') || undefined
            slsOverviewStore.fromAbsolute = searchParams.get('fromAbsolute') || undefined
            slsOverviewStore.toAbsolute = searchParams.get('toAbsolute') || undefined

            // if (searchParams.size === 0) {
            //     pageQueryStore.clear('sls')
            //     slsOverviewStore.status = [PlacementProcessStatusDto.ACTIVE]
            //     slsOverviewStore.documentExistence = [PlacementProcessDocumentExistenceFilterDto.EXISTS]
            // } else {
            //     slsOverviewStore.documentExistence = searchParams.getAll('documentExistence') || undefined
            //     slsOverviewStore.status = searchParams.getAll('status') || undefined
            //     slsOverviewStore.origins = searchParams.getAll('origins') || undefined
            // }

            slsOverviewStore.load().finally()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/sls/create`,
        element: <SlsApp mode={'create'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            validationStore.reset()
            await slsCustomerStore.init()
            await slsUserStore.init()
            slsCreateStore.reset()

            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/sls/warehouse`,
        element: <SlsApp mode={'overview'} tab={'warehouse'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            validationStore.reset()
            await slsWarehouseListStore.load()

            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/sls/warehouse/create`,
        element: <SlsApp mode={'warehouse-create'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            validationStore.reset()
            slsWarehouseCreateStore.reset()

            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/sls/warehouse/:id`,
        element: <SlsApp mode={'warehouse-detail'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({params, request}) => {
            validationStore.reset()
            slsWarehouseDetailStore.id = params.id!!

            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/sls/:id`,
        element: <SlsApp mode={'detail'}/>,
        errorElement: <Navigate to={`/sls`} replace={true}/>,
        loader: async ({params, request}) => {
            validationStore.reset()
            await slsCustomerStore.init()
            await slsUserStore.init()
            slsDetailStore.reset()

            slsDetailStore.id = params.id!!
            const result = await slsDetailStore.load()
            if (!result) {
                throw Error
            }

            navigationStore.setActivePath(request)
            return null
        }
    },
]

export {
    sls
}
